<template>
  <card-seplag titulo="Indice para Calculos">
    <div class="p-col-12 p-md-6" style="display: flex">
      <Dropdown
        v-model="indiceTaxaSelecionado"
        :options="listaIndiceTaxa"
        optionLabel="name"
        optionValue="code"
        placeholder="Filtro"
        filter
        showClear
        style="width: 100%"
      />
      <Button
        type="button"
        icon="pi pi-search"
        label="Buscar"
        style="margin-left: 2px"
        v-tooltip.top="'buscar'"
        @click="paginacaoSolicitacao(10, 0)"
      />
    </div>
    <div class="p-col-12 p-md-3">
      <Button
        type="button"
        icon="pi pi-dollar"
        label="Criar Novo Indice"
        class="p-button-success"
        v-tooltip.top="'Criar Novo Indice'"
        @click="abrirCriarIncice()"
      />
    </div>
    <DataTable
      :value="listaIndice"
      :paginator="true"
      :rows="10"
      :lazy="true"
      responsiveLayout="scroll"
      :totalRecords="totalRecords"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 20, 50]"
      currentPageReportTemplate="Mostrando {first} à {last} de {totalRecords}"
      @page="
        paginacaoSolicitacao(
          $event.originalEvent.rows,
          $event.originalEvent.page
        )
      "
      class="p-col-12 p-datatable-responsive"
    >
      <Column field="idenIndice" header="Código"></Column>
      <Column field="descricaoIndice" header="Indice"></Column>
      <Column field="valorIndice" header="Valor"></Column>
      <Column field="mesIndice" header="Mes Indice"></Column>
      <Column field="anoIndice" header="Ano Indice"></Column>
      <Column
        headerStyle="width: 6em"
        bodyStyle="text-align: center;"
        header="Ação"
      >
        <template #body="slotProps">
          <Button
            type="button"
            icon="pi pi-pencil"
            style="width: 35%"
            class="p-button-warning"
            @click="abrirEditarIndice(slotProps.data)"
            v-tooltip.top="'Editar'"
          />
          <Button
            type="button"
            icon="pi pi-times"
            style="width: 35%"
            class="p-button-danger"
            @click="deletarIndice(slotProps.data)"
            v-tooltip.top="'Excluir Indice'"
          />
        </template>
      </Column>
    </DataTable>
    <Dialog
      header="Indice de Calculo"
      :visible.sync="visualizarModalForm"
      :containerStyle="{ width: '50vw' }"
      contentStyle="overflow-y: unset"
      :modal="true"
    >
      <div class="p-grid">
        <Rotulo nome="Indice:" cols="12 3">
          <Dropdown
            v-model="registro.descricaoIndice"
            :options="listaIndiceTaxa"
            optionLabel="name"
            optionValue="code"
            placeholder="Selecione..."
            filter
            showClear
          />
        </Rotulo>
        <Rotulo nome="Mes Referente:" cols="12 3">
          <Dropdown
            v-model="registro.mesIndice"
            :options="listaMeses"
            optionLabel="name"
            optionValue="code"
            placeholder="Selecione..."
            filter
            showClear
          />
        </Rotulo>
        <Rotulo nome="Ano Referente:" cols="12 3">
          <Dropdown
            v-model="registro.anoIndice"
            :options="listaAnos"
            optionLabel="name"
            optionValue="code"
            placeholder="Selecione..."
            filter
            showClear
          />
        </Rotulo>
        <Rotulo nome="Valor Indice:" cols="12 3">
          <InputText
            type="text"
            id="valorIndice"
            v-model="registro.valorIndice"
            @input="filtrarInputNumerico"
          />
        </Rotulo>
      </div>
      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          @click="fecharModal"
          class="p-button-text"
        />
        <Button
          label="Salvar"
          icon="pi pi-save"
          @click="criarIndice"
          autofocus
        />
      </template>
    </Dialog>
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import { baseApiUrl } from "@/config/global";
const getNovoForm = () => {
  return {
    idenIndice: null,
    descricaoIndice: null,
    mesIndice: null,
    anoIndice: null,
    valorIndice: 0,
  };
};
export default {
  name: "indiceCalculo",
  components: { CardSeplag, Rotulo },
  data() {
    return {
      registro: getNovoForm(),
      listaIndice: [],
      indiceTaxaSelecionado: null,
      visualizarModalForm: false,
      totalRecords: 0,
      listaIndiceTaxa: [
        { name: "SELIC", code: "SELIC" },
        { name: "IPCA", code: "IPCA" },
      ],
      listaMeses: [
        { name: "Janeiro", code: 1 },
        { name: "Fevereiro", code: 2 },
        { name: "Março", code: 3 },
        { name: "Abril", code: 4 },
        { name: "Maio", code: 5 },
        { name: "Junho", code: 6 },
        { name: "Julho", code: 7 },
        { name: "Agosto", code: 8 },
        { name: "Setembro", code: 9 },
        { name: "Outubro", code: 10 },
        { name: "Novembro", code: 11 },
        { name: "Dezembro", code: 12 },
      ],
      listaAnos: [],
    };
  },
  methods: {
    carregarDados() {
      let anoAtual = new Date().getFullYear();
      for (let ano = 2010; ano <= anoAtual; ano++) {
        this.listaAnos.push({ name: ano, code: ano });
      }
      let bodyRequest = {
        indiceMes: null,
        indiceAno: null,
        descricaoIndice: null,
      };
      this.$http
        .post(
          `${baseApiUrl}/indices/filtro?size=10&page=0&sort=anoIndice,asc&sort=mesIndice,asc`,
          JSON.stringify(bodyRequest)
        )
        .then((res) => {
          this.listaIndice = res.data.content;
          this.totalRecords = res.data.totalElements;
        });
    },
    paginacaoSolicitacao(row = 10, page = 0) {
      let jsonBody = {
        indiceMes: null,
        indiceAno: null,
        descricaoIndice: this.indiceTaxaSelecionado,
      };
      this.$http
        .post(
          `${baseApiUrl}/indices/filtro?size=${row}&page=${page}&sort=anoIndice,asc&sort=mesIndice,asc`,
          JSON.stringify(jsonBody)
        )
        .then((res) => {
          this.listaIndice = res.data.content;
          this.totalRecords = res.data.totalElements;
        });
    },
    abrirCriarIncice() {
      this.registro = getNovoForm();
      this.visualizarModalForm = true;
    },
    abrirEditarIndice(data) {
      this.registro = { ...data };
      //console.log(this.registro.anoIndice);

      this.visualizarModalForm = true;
    },
    criarIndice() {
      if (this.registro.idenIndice == null) {
        this.$http
          .post(`${baseApiUrl}/indices`, JSON.stringify(this.registro))
          .then(() => {
            this.$toast.add({
              severity: "success",
              summary: "Indice criado com Sucesso.",
              life: 3000,
            });
            this.carregarDados();
          });
      } else {
        this.editarIndice();
      }
    },
    editarIndice() {
      this.$http
        .put(
          `${baseApiUrl}/indices/${this.registro.idenIndice}`,
          JSON.stringify(this.registro)
        )
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Indice Aualizado com Sucesso.",
            life: 3000,
          });
          this.carregarDados();
        });
    },
    deletarIndice(data) {
      this.$http.delete(`${baseApiUrl}/indices/${data.idenIndice}`).then(() => {
        this.$toast.add({
          severity: "success",
          summary: "Indice Aualizado com Sucesso.",
          life: 3000,
        });
        this.carregarDados();
      });
    },
    fecharModal() {
      this.visualizarModalForm = false;
    },
    filtrarInputNumerico() {
      // Remove tudo que não for número ou ponto
      let valorFiltrado = this.registro.valorIndice.replace(/[^0-9.]/g, "");
      // Atualiza o valor do input com o valor filtrado
      this.registro.valorIndice = valorFiltrado;
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>

<style></style>
